var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.bem()},[_c('swiper-container',{class:_vm.bem('swiper'),attrs:{"loop":true,"autoplay-delay":3000,"pagination":{
      clickable: true,
    }}},_vm._l((_vm.carouselList),function(item,index){return _c('swiper-slide',{key:index,class:_vm.bem('slide')},[_c('div',{class:_vm.bem('item')},[_c('img',{class:_vm.bem(''),attrs:{"src":item.img,"alt":""}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }